// extracted by mini-css-extract-plugin
export default {"root":"installAppBanner_root__8OSvZ","closeButton":"installAppBanner_closeButton__GhIBu"};